import React from 'react';

const Cookies = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="103"
      height="104"
      viewBox="0 0 103 104"
    >
      <g>
        <g>
          <g>
            <path
              fill="#7cc4ac"
              d="M29.005 41.707a4.978 4.978 0 0 1-4.972-4.972 4.978 4.978 0 0 1 4.972-4.972 4.978 4.978 0 0 1 4.972 4.972 4.978 4.978 0 0 1-4.972 4.972zM29 28.73c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.59-8-8-8z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M63.005 78.707a4.978 4.978 0 0 1-4.972-4.972 4.978 4.978 0 0 1 4.972-4.972 4.978 4.978 0 0 1 4.972 4.972 4.978 4.978 0 0 1-4.972 4.972zM63 65.73c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M32.5 71.64c-1.88 0-3.41-1.53-3.41-3.41 0-1.88 1.53-3.41 3.41-3.41 1.88 0 3.41 1.53 3.41 3.41 0 1.88-1.53 3.41-3.41 3.41zm0-9.91a6.507 6.507 0 0 0-6.5 6.5c0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M49.5 45.862c-.9 0-1.632-.732-1.632-1.632 0-.9.732-1.632 1.632-1.632.9 0 1.632.732 1.632 1.632 0 .9-.732 1.632-1.632 1.632zm0-6.132a4.505 4.505 0 0 0-4.5 4.5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M81.828 66.631l-1.742-3.1c-.402-.715-1.38-1.006-2.185-.647-.805.358-1.131 1.228-.729 1.945l1.742 3.1c.285.507.86.801 1.458.801.245 0 .493-.05.727-.153.805-.359 1.131-1.23.729-1.946z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M66.847 54.631c-.359-.805-1.23-1.131-1.946-.728l-3.1 1.74c-.715.403-1.006 1.381-.648 2.186.254.571.766.901 1.298.901.218 0 .44-.055.648-.172l3.1-1.741c.715-.403 1.006-1.381.648-2.186z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M20.828 53.631l-1.742-3.099c-.402-.716-1.38-1.007-2.185-.648-.805.358-1.131 1.229-.729 1.945l1.742 3.1c.285.507.86.801 1.458.801.245 0 .493-.05.727-.153.805-.358 1.131-1.23.729-1.946z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M44.847 80.631c-.358-.805-1.23-1.131-1.946-.729l-3.1 1.742c-.715.402-1.006 1.38-.648 2.185.254.571.766.901 1.298.901.218 0 .44-.055.648-.172l3.1-1.741c.715-.403 1.006-1.381.648-2.186z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M44.523 18.949l-1.742-1.742a1.63 1.63 0 0 0-2.304 2.304l1.742 1.742c.318.318.735.477 1.152.477a1.63 1.63 0 0 0 1.152-2.781z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M41.523 55.949l-1.742-1.742a1.63 1.63 0 1 0-2.304 2.304l1.742 1.742c.318.318.735.477 1.152.477a1.63 1.63 0 0 0 1.152-2.781z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M51.523 27.207a1.63 1.63 0 0 0-2.304 0l-1.742 1.742a1.63 1.63 0 1 0 2.304 2.304l1.742-1.742a1.63 1.63 0 0 0 0-2.304z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M84.911 16.066l-1.438 5.98a3.35 3.35 0 0 1-1.657 2.191 3.13 3.13 0 0 1-2.677.174l-4.035-1.573c-1.465-.57-2.341-2.149-2.084-3.752l.456-2.843c.204-1.272 1.104-2.334 2.293-2.705l5.018-1.564c.318-.1.64-.148.958-.148.826 0 1.625.328 2.249.947a3.459 3.459 0 0 1 .917 3.293zm1.147-5.53c-1.65-1.635-3.937-2.205-6.12-1.524l-5.022 1.566c-2.268.707-3.986 2.732-4.375 5.16l-.456 2.845c-.49 3.06 1.182 6.07 3.976 7.16l4.039 1.573a6.044 6.044 0 0 0 5.106-.331c1.577-.86 2.73-2.385 3.162-4.181l1.44-5.985c.552-2.298-.102-4.646-1.75-6.282z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M93.462 39.112l-2.6 2.999a1.772 1.772 0 0 1-1.615.594 1.727 1.727 0 0 1-1.372-1.013l-1.616-3.625c-.369-.827-.002-1.79.836-2.192l2.009-.965a1.812 1.812 0 0 1 1.854.16l2.207 1.591c.392.283.639.696.696 1.164.056.468-.085.925-.399 1.287zm3.504-1.63c-.157-1.292-.84-2.434-1.923-3.215l-2.21-1.593a5.025 5.025 0 0 0-5.12-.443l-2.01.966c-2.313 1.111-3.326 3.77-2.308 6.055l1.618 3.629c.676 1.514 2.092 2.56 3.788 2.799.241.033.481.05.72.05 1.439 0 2.8-.606 3.742-1.692l2.603-3.003a4.534 4.534 0 0 0 1.1-3.553z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M98.5 24.861c-.9 0-1.632-.732-1.632-1.631 0-.9.732-1.632 1.632-1.632.9 0 1.632.732 1.632 1.632 0 .9-.732 1.631-1.632 1.631zm0-6.131a4.505 4.505 0 0 0-4.5 4.5c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M101.126 57.938a3.194 3.194 0 0 0-2.74-.914c-.686.101-1.382.153-2.068.153-6.347 0-11.915-4.076-13.857-10.143-.53-1.658-1.89-2.885-3.548-3.202-11.383-2.176-19.646-12.208-19.646-23.853 0-4.809 1.403-9.461 4.057-13.454a3.14 3.14 0 0 0 .293-2.94 3.126 3.126 0 0 0-2.287-1.873 51.486 51.486 0 0 0-15.592-.68c-10.473 1.133-20.234 5.47-28.229 12.542a1.513 1.513 0 0 0-.134 2.13 1.499 1.499 0 0 0 2.122.134c7.526-6.658 16.71-10.74 26.562-11.805a48.498 48.498 0 0 1 14.688.64c.035.007.073.02.093.069.02.045.004.079-.016.108a27.241 27.241 0 0 0-4.563 15.13c0 13.092 9.29 24.37 22.09 26.817.576.11 1.054.554 1.248 1.16 2.342 7.32 9.061 12.237 16.719 12.237.832 0 1.675-.062 2.505-.184.11-.016.167.05.17.066a48.39 48.39 0 0 1-11.384 24.149 1.513 1.513 0 0 0 .137 2.13 1.497 1.497 0 0 0 2.121-.137A51.41 51.41 0 0 0 101.96 60.56a3.019 3.019 0 0 0-.834-2.623z"
            />
          </g>
          <g>
            <path
              fill="#7cc4ac"
              d="M85.624 88.774a1.509 1.509 0 0 0-2.13-.136 48.398 48.398 0 0 1-31.99 12.074c-6.791 0-13.36-1.377-19.523-4.092a48.32 48.32 0 0 1-15.735-11.116A48.25 48.25 0 0 1 6.071 69.187C3.708 62.862 2.709 56.19 3.1 49.353c.61-10.657 4.876-20.998 12.012-29.117a1.51 1.51 0 0 0-2.266-1.993C5.268 26.866.737 37.853.087 49.18c-.415 7.257.647 14.344 3.157 21.064a51.25 51.25 0 0 0 10.808 17.332 51.328 51.328 0 0 0 16.713 11.807c6.549 2.884 13.526 4.347 20.739 4.347a51.415 51.415 0 0 0 33.984-12.826 1.51 1.51 0 0 0 .136-2.13z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Cookies;
